// API Configuration
// Set NEXT_PUBLIC_API_URL to your API domain (e.g., https://staging.dalal.live)
// The /api prefix will be added in individual endpoint definitions
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000';

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
  },
  // Add more endpoint groups as needed
};

export const menuItems = [
  { title: "About Us", href: "/#about" },
  { title: "Commission", href: "/#commission" },
  { title: "Help Center", href: "/help-center" },
  { title: "Contact Us", href: "/#contact-us" },
];

export const whyChooseUsData = [
  {
    title: "Expert-Backed Success",
    short: "✅ Sharpen your edge with insights from market leaders.",
    long: `Our elite team combines decades of South Asian affiliate expertise, 
data-driven strategies, and relentless innovation. With Dalal, 
you're not just joining a program – you're arming yourself with 
battle-tested tools from the region's top performers.`,
    img: "https://ap-south-1.graphassets.com/cmbkah9he0oy007pogtggbqnf/cmbpvbduw34qo07pmh5gpncui",
  },
  {
    title: "Free Registration & Easy Onboarding",
    short: "✅ Strike fast – start earning in minutes, not days.",
    long: `Zero upfront costs, fast approval, and a seamless onboarding process 
let you promote and profit immediately. No delays – just pure 
earnings potential from Day 1.`,
    img: "https://ap-south-1.graphassets.com/cmbkah9he0oy007pogtggbqnf/cmbpvktbh34wg07pmj69ot80c",
  },
  {
    title: "Local Service",
    short: "✅ Global reach, Bangladeshi roots.",
    long: `Our elite team combines decades of South Asian affiliate expertise, 
data-driven strategies, and relentless innovation. With Dalal, 
you're not just joining a program – you're arming yourself with 
battle-tested tools from the region's top performers.`,
    img: "https://ap-south-1.graphassets.com/cmbkah9he0oy007pogtggbqnf/cmbpvbduw34qo07pmh5gpncui",
  },
  {
    title: "Flat Commission",
    short: "✅ No tier climbing – just straight, hard-hitting earnings.",
    long: `Zero upfront costs, fast approval, and a seamless onboarding process 
let you promote and profit immediately. No delays – just pure 
earnings potential from Day 1.`,
    img: "https://ap-south-1.graphassets.com/cmbkah9he0oy007pogtggbqnf/cmbpvktbh34wg07pmj69ot80c",
  },
  {
    title: "Real-Time Tracking Dashboard",
    short: "✅ Stay sharp with live data at your claws.",
    long: `Our elite team combines decades of South Asian affiliate expertise, 
data-driven strategies, and relentless innovation. With Dalal, 
you're not just joining a program – you're arming yourself with 
battle-tested tools from the region's top performers.`,
    img: "https://ap-south-1.graphassets.com/cmbkah9he0oy007pogtggbqnf/cmbpvbduw34qo07pmh5gpncui",
  },
  {
    title: "Lightning Payouts",
    short: "✅ Strike fast, withdraw faster.",
    long: `Zero upfront costs, fast approval, and a seamless onboarding process 
let you promote and profit immediately. No delays – just pure 
earnings potential from Day 1.`,
    img: "https://ap-south-1.graphassets.com/cmbkah9he0oy007pogtggbqnf/cmbpvktbh34wg07pmj69ot80c",
  },
];

export const affiliateFaqData = [
  {
    q: "What does a Dalal Affiliates actually do?",
    a: `An affiliate is a promoter (like you!) who earns commissions by referring players to Dalal. Think of yourself as a jungle guide – you lead players to the best gaming experience, and we reward you with lifetime earnings. No experience needed!`,
  },
  {
    q: "Is there a registration fee?",
    a: `Never! Joining Dalal Affiliates is 100% free with no hidden costs.`,
  },
  {
    q: "How do I track my referrals?",
    a: `Your real-time dashboard shows data, sign-ups, and earnings by players.`,
  },
  {
    q: "What’s the minimum activity to qualify a player for my commissions?",
    a: `You only need 1 active player (someone who makes at least one deposit) to start earning commissions. No complicated quotas – just bring 'em in!`,
  },
  {
    q: "What’s negative carryforward (NCF)?",
    a: `If players win, losses carry to next payout period (standard for program stability).`,
  },
  {
    q: "Can I refer myself?",
    a: `No, referring yourself is strictly prohibited and can lead to account suspension.`,
  },
  {
    q: "What is KYC?",
    a: `KYC (Know Your Customer) is a one-time identity verification to keep earnings secure. For affiliates:

✅ Only needed before first payout (submit via affiliate dashboard in <5 mins)
✅ Protects your commissions from fraud

We verify once so you earn worry-free forever!`,
  },
  {
    q: "Why do you need to do KYC?",
    a: `To ensure transparency and comply with international regulations. It’s for your safety and ours!`,
  },
];

export const affiliateCardsList = [
  {
    type: "players",
    image: "/assets/affiliates-players-1.png",
  },
  {
    type: "players",
    image: "/assets/affiliates-players-2.webp",
  },
  {
    type: "players",
    image: "/assets/affiliates-players-3.png",
  },
  {
    type: "players",
    image: "/assets/affiliates-players-4.webp",
  },
  {
    type: "players",
    image: "/assets/affiliates-players-5.webp",
  },
  {
    type: "players",
    image: "/assets/affiliates-players-6.webp",
  },
  {
    type: "affiliates",
    image: "/assets/affiliate-recruit-1.png",
  },
  {
    type: "affiliates",
    image: "/assets/affiliate-recruit-2.png",
  },
  {
    type: "affiliates",
    image: "/assets/affiliate-recruit-3.png",
  },
  {
    type: "affiliates",
    image: "/assets/affiliate-recruit-4.png",
  },
  {
    type: "affiliates",
    image: "/assets/affiliate-recruit-5.png",
  },
  {
    type: "affiliates",
    image: "/assets/affiliate-recruit-6.png",
  },
  {
    type: "affiliates",
    image: "/assets/affiliate-recruit-7.png",
  },
  {
    type: "affiliates",
    image: "/assets/affiliate-recruit-8.png",
  },
];
